export const COMMITTEES_TRANSLATE = {
    committees: {
        breadcrumbName: "Comités",
        messages: {
            create: "Comité agregado exitosamente",
            update: "Comité actualizado exitosamente",
            delete: "Comité desactivado exitosamente",
            recover: "Comité restaurado exitosamente"
        },
        list: {
            table: {
                columns: {
                    id: "ID",
                    name: "Nombre"
                }
            },
            filters: {
                fields: {
                    id: {
                        label: "ID",
                        placeholder: "Ingrese el ID",
                        url: "id"
                    },
                    name: {
                        label: "Nombre",
                        placeholder: "Ingrese el nombre",
                        url: "name"
                    },
                    active: {
                        label: "Estado",
                        placeholder: "Seleccione el estado",
                        url: "status"
                    }
                }
            },
            dialog: {
                delete: {
                    title: "Desactivar comité",
                    body: "¿Está seguro de que desea desactivar el comité con ID {{id}}?",
                    save: {
                        text: "Sí, desactivar"
                    },
                    back: {
                        text: "Volver"
                    },
                }
            }
        },
        save: {
            form: {
                fields: {
                    name: {
                        label: "Nombre",
                        placeholder: "Ingrese el nombre"
                    },
                    userIds: {
                        label: "Usuarios",
                        placeholder: "Seleccione los usuarios"
                    },
                    categoryIds: {
                        label: "Categorías",
                        placeholder: "Seleccione las categorías"
                    },
                }
            }
        },
        dictionaries: {
            breadcrumb: "Diccionarios",
            messages: {
                create: "Diccionario creado exitosamente",
                update: "Diccionario actualizado exitosamente",
                delete: "Diccionario eliminado exitosamente",
                recover: "Diccionario restaurado exitosamente"
            },
            list: {
                table: {
                    columns: {
                        id: "ID",
                        language: "Idioma",
                        name: "Nombre"
                    }
                },
                dialog: {
                    delete: {
                        title: "Eliminar diccionario",
                        body: "¿Está seguro de que desea eliminar el diccionario con ID {{id}}?",
                        save: {
                            text: "Sí, eliminar"
                        },
                        back: {
                            text: "Volver"
                        }
                    }
                }
            },
            save: {
                form: {
                    fields: {
                        languageId: {
                            label: "Idioma",
                            placeholder: "Seleccione el idioma"
                        },
                        name: {
                            label: "Nombre",
                            placeholder: "Ingrese el nombre"
                        }
                    }
                }
            }
        }
    }
}
